// Contador de «personas viendo este producto».
//
// ⚠️ El numero es SIMULADO. Contar sesiones vivas de verdad exige estado
// compartido entre visitantes, y Liquid se renderiza en servidor sin memoria
// entre peticiones: haria falta un backend propio, un beacon desde el tema y
// caducidad de sesiones. Se decidio con la clienta el 2026-08-21.
//
// Va en JS y no en Liquid por una razon concreta: la cache de pagina de Shopify
// serviria el mismo numero a todos los visitantes durante horas, que es la
// forma mas rapida de que se note que es falso.
//
// El defecto tipico de las apps de este tipo es que el numero salta: una resena
// de Livify se queja de «84 a 57 en segundos». Aqui no puede pasar: se elige un
// numero una sola vez, se guarda en sessionStorage por producto y a partir de
// ahi solo se mueve de uno en uno. Volver atras en el navegador recupera el
// mismo valor en vez de inventar otro.
(function () {
  var el = document.querySelector('[data-bl-viewers]');
  if (!el) return;

  var out = el.querySelector('[data-bl-viewers-text]');
  if (!out) return;

  var min = parseInt(el.dataset.min, 10);
  var max = parseInt(el.dataset.max, 10);
  if (!isFinite(min) || !isFinite(max)) return;
  if (min < 1) min = 1;
  // El editor no impide poner el minimo por encima del maximo.
  if (max < min) max = min;

  var key = 'bl-viewers-' + (el.dataset.key || 'p');
  var MAX_AGE = 30 * 60 * 1000; // pasada media hora, la visita ya es otra

  function store(n) {
    try {
      sessionStorage.setItem(key, JSON.stringify({ n: n, t: Date.now() }));
    } catch (e) {
      // Safari en navegacion privada tira al escribir. El contador sigue
      // funcionando, solo pierde la continuidad entre paginas.
    }
  }

  function restore() {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var saved = JSON.parse(raw);
      if (!saved || typeof saved.n !== 'number') return null;
      if (Date.now() - saved.t > MAX_AGE) return null;
      if (saved.n < min || saved.n > max) return null;
      return saved.n;
    } catch (e) {
      return null;
    }
  }

  var count = restore();
  if (count === null) count = min + Math.floor(Math.random() * (max - min + 1));

  function render() {
    var text =
      count === 1
        ? el.dataset.one
        : (el.dataset.other || '').replace('__N__', String(count));
    out.textContent = text;
    el.hidden = false;
  }

  function drift() {
    // Tres de cada cuatro veces se queda quieto: un numero que cambia cada
    // pocos segundos delata que es generado.
    if (Math.random() < 0.75) return;
    var step = Math.random() < 0.5 ? -1 : 1;
    var next = count + step;
    if (next < min || next > max) next = count - step;
    if (next < min || next > max) return;
    count = next;
    store(count);
    render();
  }

  store(count);
  render();

  // Sin intervalo si el rango no da juego, y sin gastar temporizador mientras
  // la pestana esta en segundo plano.
  if (max === min) return;
  var timer = setInterval(function () {
    if (document.hidden) return;
    drift();
  }, 9000);

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') return;
    drift();
  });

  window.addEventListener('pagehide', function () {
    clearInterval(timer);
  });
})();
